<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="irInicio">Inicio</span> > Usuarios</p>
    </div>
  </div>
  
  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo"><h5 class="mx-4 mt-5 mb-5">Listado de Usuarios</h5></div>
          <div class="table-search">
            <input id="textoBuscador" type="text" class="form-control" placeholder="Búsqueda rápida..." aria-label="Búsqueda rápida" @input="teclearBuscador" />
          </div>
          <div class="descarga triple">
            <p @click="descargarCSV"><i class="fa fa-download" aria-hidden="true"></i></p>
            <p @click="abrirAltaUsuario"><i class="fa fa-plus" aria-hidden="true"></i></p>
            <p @click="toggleSelectorColumnas" title="Columnas visibles" :class="{ 'activo': selectorColumnasAbierto }"><i class="fas fa-columns" aria-hidden="true"></i></p>
          </div>

          <!-- Selector de columnas -->
          <div v-if="selectorColumnasAbierto" class="selector-columnas-panel" v-click-outside="cerrarSelectorColumnas">
            <div class="selector-columnas-header">
              <span>Columnas visibles</span>
              <button class="selector-reset" @click="resetColumnas" title="Restablecer">Restablecer</button>
            </div>
            <div class="selector-columnas-grid">
              <label v-for="col in columnasConfig" :key="col.key" class="selector-col-item" :class="{ disabled: col.fija }">
                <input type="checkbox" v-model="columnasVisibles[col.key]" :disabled="col.fija" @change="guardarColumnasStorage" />
                <span class="selector-col-dot" :style="{ background: col.color }"></span>
                <span>{{ col.label }}</span>
              </label>
            </div>
          </div>
          <div class="filtros-btn-wrap" v-if="miRol == 1">
            <button class="btn-filtros" :class="{ activo: hayFiltrosActivos }" @click="mostrarFiltros = !mostrarFiltros">
              <i class="fas fa-filter"></i>
              Filtros
              <span v-if="hayFiltrosActivos" class="filtro-badge">{{ contadorFiltros }}</span>
            </button>
          </div>
          <div class="borrados">
            <QToggle v-model="mostrarBorrados" @change="cambiarBorrados" />
            <span class="borrados-label">{{ mostrarBorrados ? 'Con eliminados' : 'Sin eliminados' }}</span>
          </div>
        </div>

        <div v-show="mostrarFiltros && miRol == 1" class="filtros-panel card mt-2 px-4 py-3">
          <div class="filtros-grid">
            <div class="filtro-grupo">
              <label class="filtro-label">Tipster</label>
              <select v-model="filtros.tipster_id" class="filtro-input">
                <option value="">Todos</option>
                <option v-for="t in listaTipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
              </select>
            </div>
            <div class="filtro-grupo">
              <label class="filtro-label">Rol</label>
              <select v-model="filtros.rol_id" class="filtro-input">
                <option value="">Todos</option>
                <option v-for="r in listaRoles" :key="r.id" :value="r.id">{{ r.nombre }}</option>
              </select>
            </div>
          </div>
          <div class="filtros-acciones">
            <button class="btn-f-aplicar" @click="aplicarFiltros">Aplicar filtros</button>
            <button class="btn-f-limpiar" @click="limpiarFiltros">Limpiar</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-listado mt-4">
          <div class="px-4 pb-0 card-body">
            <div class="table-responsive mb-4">
              <table id="usuarios-list" class="table table-flush table-listado">
                <thead class="thead-light">
                  <tr>
                    <th @click="sortTable('0')" :class="sortColumn=='0' ? sortDirection : ''">Usuario</th>
                    <th @click="sortTable('1')" :class="[sortColumn=='1' ? sortDirection : '', { 'd-none': !columnasVisibles.nombre }]">Nombre</th>
                    <th @click="sortTable('2')" :class="sortColumn=='2' ? sortDirection : ''">Email</th>
                    <th @click="sortTable('3')" :class="[sortColumn=='3' ? sortDirection : '', { 'd-none': !columnasVisibles.rol }]">Rol</th>
                    <th @click="sortTable('4')" :class="[sortColumn=='4' ? sortDirection : '', { 'd-none': !columnasVisibles.tipster }]" v-if="miRol==1">Tipster</th>
                    <th @click="sortTable('5')" :class="[sortColumn=='5' ? sortDirection : '', { 'd-none': !columnasVisibles.creado }]" data-type="date" data-format="DD/MM/YYYY">Creado</th>
                    <th @click="sortTable('6')" :class="[sortColumn=='6' ? sortDirection : '', { 'd-none': !columnasVisibles.eliminado }]" v-if="mostrarBorrados">Eliminado</th>
                    <th data-type="html" data-sortable="false" class="sin-orden">Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <!-- Ciclo a través de los elementos filtrados y paginados -->
                  <tr v-for="row in filas" :key="row.id">
                    <td>{{ row.username }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.nombre }">{{ row.nombre }}</td>
                    <td>{{ row.email }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.rol }">{{ row.rol_name }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.tipster }" v-if="miRol==1">{{ row.tipster_name }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.creado }">{{ row.created }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.eliminado }" v-if="mostrarBorrados">{{ row.deleted }}</td>
                    <td>
                      <template v-if="!row.deleted">
                        <a href="#" class="cursor-pointer me-3" title="Editar Usuario" @click.prevent="editarUsuario(row.id)">
                          <i class="fas fa-user-edit text-secondary"></i>
                        </a>
                        <a href="#" class="cursor-pointer me-3" title="Eliminar Usuario" @click.prevent="mostrarConfirmacionBorrar(row.id)">
                          <i class="fas fa-trash text-secondary"></i>
                        </a>
                        <a href="#" class="cursor-pointer me-3" title="Cambiar clave Usuario" @click.prevent="cambiarClaveUsuario(row.id)">
                          <i class="fas fa-key text-secondary"></i>
                        </a>
                        <a v-if="miRol==1 && row.rol_id != 1" href="#" class="cursor-pointer me-3" title="Impersonalizar usuario" @click.prevent="impersonalizarUsuario(row.id)">
                          <i class="fas fa-user-secret text-secondary"></i>
                        </a>
                      </template>
                    </td>
                  </tr>
                  <tr v-if="filas.length==0"><td colspan="7">No hay registros que mostrar</td></tr>
                </tbody>
              </table>
            </div>
            <!-- Control de la Paginacion manual -->
            <div class="paginacion" v-if="filas.length>0">
              <p class="contador-listado">Mostrando {{ mostradosIni }} a {{ mostradosFin }} de {{ mostradosTotal }} registros</p>

              <ul class="pagination pagination-md" v-if="paginaTotal>1">
                <li class="page-item prev-page" v-if="paginaActual>1">
                  <a class="page-link" aria-label="Previous" @click="paginaActual=paginaActual-1;fetchAndSetUsuarios();">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                  </a>
                </li>
                <li v-for="index in rangoPaginas" :key="index" class="page-item" :class="index==paginaActual ? 'active disabled' : ''">
                  <a class="page-link" @click="paginaActual=index;fetchAndSetUsuarios();">{{index}}</a>
                </li>
                <li class="page-item next-page" v-if="paginaActual<paginaTotal">
                  <a class="page-link" aria-label="Next" @click="paginaActual=paginaActual+1;fetchAndSetUsuarios();">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal @cerrar-modal="cerrarModal" :modalActive="modalActive">
    <div class="modal-content">
      <usuario-form v-if="tipoModal=='A'" modo="alta" @cerrar-modal="() => { this.modalActive=false;fetchAndSetUsuarios();}" :key="0"></usuario-form>
      <usuario-form v-if="tipoModal=='E'" modo="edita" @cerrar-modal="() => { this.modalActive=false;fetchAndSetUsuarios();}" :key="usuarioEditId" :usuarioId="usuarioEditId" :usuarioName="usuarioEditName" :usuarioUsername="usuarioEditUsername" :usuarioEmail="usuarioEditEmail" :usuarioRolId="usuarioEditRol" :usuarioTipsterId="usuarioEditTipster" :usuarioEsPersonalizado="usuarioEditEsPersonalizado" :usuarioRolBaseId="usuarioEditRolBaseId" :usuarioPermisosAllow="usuarioEditPermisosAllow" :usuarioPermisosDeny="usuarioEditPermisosDeny"></usuario-form>
      <cambio-clave-usuario-form v-if="tipoModal=='C'" @cerrar-modal="() => { this.modalActive=false;}" :key="2" :usuarioId="usuarioEditId" :usuarioUsername="usuarioEditUsername" :usuarioEmail="usuarioEditEmail"></cambio-clave-usuario-form>
    </div>
  </Modal>

  <div v-if="confirmacionVisible" class="overlay">
    <div class="confirm-box">
      <p class="mt-4 mb-4">{{ mensajeConfirmacion }}</p>
      <table class="mt-4 mb-4"><tr>
        <td width="50%"><QBtn variant="cancela" label="Cancelar" @click="cancelacion" /></td>
        <td width="50%"><QBtn variant="confirma" label="Confirmar" @click="confirmacion" /></td>
      </tr></table>
    </div>
  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import Modal from './components/Modal.vue';
import UsuarioForm from './components/UsuarioForm.vue';
import CambioClaveUsuarioForm from './components/CambioClaveUsuarioForm.vue';
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

const STORAGE_KEY_COLUMNAS = 'usuarios_columnas_v1';

const COLUMNAS_DEFAULT = {
  nombre: true, rol: true, tipster: true, creado: true, eliminado: true,
};

const COLUMNAS_MOBILE = {
  nombre: false, rol: false, tipster: false, creado: false, eliminado: false,
};

export default {
  name: "Usuarios",
  components: {
    Modal,
    UsuarioForm,
    CambioClaveUsuarioForm,
  },
  directives: {
    clickOutside: {
      beforeMount(el, binding) {
        el._clickOutsideHandler = (e) => { if (!el.contains(e.target)) binding.value(e); };
        setTimeout(() => document.addEventListener('click', el._clickOutsideHandler), 0);
      },
      unmounted(el) { document.removeEventListener('click', el._clickOutsideHandler); },
    },
  },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      filas: [],
      usuarios: [],
      confirmacionVisible: false,
      usuarioId: 0,
      mensajeConfirmacion: '',
      tipoModal: '',
      usuarioEditId: 0,
      usuarioEditUsername: '',
      usuarioEditEmail: '',
      usuarioEditName: '',
      usuarioEditRol: '',
      usuarioEditTipster: '',
      usuarioEditEsPersonalizado: 0,
      usuarioEditRolBaseId: null,
      usuarioEditPermisosAllow: [],
      usuarioEditPermisosDeny: [],
      textoBuscador: '',
      paginaActual: 0,
      paginaTotal: 0,
      mostrarBorrados: false,
      mostradosIni: 0,
      mostradosFin: 0,
      mostradosTotal: 0,
      sortColumn: 0,
      sortDirection: '',
      modalActive: false,
      searchTimeout: null,
      mostrarFiltros: false,
      listaTipsters: [],
      listaRoles: [],
      filtros: {
        tipster_id: '',
        rol_id: '',
      },
      selectorColumnasAbierto: false,
      columnasVisibles: { ...COLUMNAS_DEFAULT },
    };
  },
  computed: {
    miRol() { return this.$store.getters["auth/rolEfectivo"]; },
    columnasConfig() {
      const cols = [
        { key: 'nombre',   label: 'Nombre', color: '#6b7280' },
        { key: 'rol',      label: 'Rol',    color: '#8b5cf6' },
        { key: 'creado',   label: 'Creado', color: '#6b7280' },
      ];
      if (Number(this.miRol) === 1) {
        cols.splice(2, 0, { key: 'tipster', label: 'Tipster', color: '#6b7280' });
      }
      if (this.mostrarBorrados) {
        cols.push({ key: 'eliminado', label: 'Eliminado', color: '#ef4444' });
      }
      return cols;
    },
    hayFiltrosActivos() {
      return Object.values(this.filtros).some(v => v !== '');
    },
    contadorFiltros() {
      return Object.values(this.filtros).filter(v => v !== '').length;
    },
    rangoPaginas() {
      let startPage = Math.max(this.paginaActual - 3, 1);
      let endPage = Math.min(this.paginaActual + 3,this.paginaTotal);
      let pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    toggleSelectorColumnas() {
      this.selectorColumnasAbierto = !this.selectorColumnasAbierto;
    },
    cerrarSelectorColumnas() {
      this.selectorColumnasAbierto = false;
    },
    guardarColumnasStorage() {
      try { localStorage.setItem(STORAGE_KEY_COLUMNAS, JSON.stringify(this.columnasVisibles)); } catch (e) { /* storage no disponible */ }
    },
    resetColumnas() {
      const esMobile = window.innerWidth < 768;
      this.columnasVisibles = { ...(esMobile ? COLUMNAS_MOBILE : COLUMNAS_DEFAULT) };
      this.guardarColumnasStorage();
    },
    cargarColumnasStorage() {
      try {
        const guardado = localStorage.getItem(STORAGE_KEY_COLUMNAS);
        if (guardado) {
          this.columnasVisibles = { ...COLUMNAS_DEFAULT, ...JSON.parse(guardado) };
        } else {
          this.columnasVisibles = { ...(window.innerWidth < 768 ? COLUMNAS_MOBILE : COLUMNAS_DEFAULT) };
        }
      } catch {
        this.columnasVisibles = { ...COLUMNAS_DEFAULT };
      }
    },
    alert() {
      showSwal.methods.showSwal({
        type: "error",
        message: "This is a PRO feature.",
        width: 400,
      });
    },

    async descargarCSV() {
      try {
        const response = await this.$store.dispatch("auth/exportarUsuarios");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "usuarios_" + new Date().toISOString().slice(0, 10) + ".xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: "No se pudo generar el archivo.", width: 400 });
      }
    },

    async initializeDataTable() {

      this.sortColumn=5;
      this.sortDirection='desc';
      this.textoBuscador = '';
      this.paginaActual = 1;
      await this.fetchAndSetUsuarios();

    },

    sortTable(key) {
      // Alternar entre ascendente y descendente al hacer clic en el encabezado
      if (this.sortColumn === key) {
        this.sortDirection = this.sortDirection=='asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = key;
        this.sortDirection = 'asc';
      }
      this.fetchAndSetUsuarios();
    },

    teclearBuscador(event) {
      this.textoBuscador = event.target.value;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchAndSetUsuarios();
      }, 500);
    },

    aplicarFiltros() {
      this.paginaActual = 1;
      this.fetchAndSetUsuarios();
    },
    limpiarFiltros() {
      this.filtros = { tipster_id: '', rol_id: '' };
      this.paginaActual = 1;
      this.fetchAndSetUsuarios();
    },

    async fetchAndSetUsuarios() {
      try {
        // Petición al servidor
        const response = await this.$store.dispatch("auth/usuarios", {
          textoBuscador: this.textoBuscador,
          paginaActual: this.paginaActual,
          mostrarBorrados: this.mostrarBorrados,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          tipster_id: this.filtros.tipster_id || null,
          rol_id: this.filtros.rol_id || null,
        });
        this.usuarios = response.data;

        // Procesar los datos y actualizarlos en el DataTable
        this.filas = response.data.map(row => ({
          id: row.id,
          username: row.username,
          nombre: row.nombre,
          email: row.email,
          rol_id: row.rol_id,
          rol_name: row.rol_name,
          tipster_name: row.tipster_name,
          created: this.formatDate(row.created_at, 'DD/MM/YYYY'),
          deleted: row.deleted_at ? this.formatDate(row.deleted_at, 'DD/MM/YYYY') : '',
        }));

        this.paginaTotal = response.paginas;
        this.mostradosIni = (response.actual-1)*response.porpagina + 1;
        this.mostradosFin = Math.min(response.totales,response.actual*response.porpagina);
        this.mostradosTotal = response.totales;

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },

    editarUsuario(id) {
      const usuario = this.usuarios.find(r => r.id == id);
      if (!usuario) return;
      this.modalActive = true;
      this.tipoModal = 'E';
      this.usuarioEditUsername = usuario.username;
      this.usuarioEditEmail = usuario.email;
      this.usuarioEditName = usuario.nombre;
      this.usuarioEditRol = usuario.rol_id.toString();
      this.usuarioEditTipster = usuario.tipster_id?.toString() ?? '';
      this.usuarioEditEsPersonalizado = usuario.es_personalizado ?? 0;
      this.usuarioEditRolBaseId = usuario.rol_base_id ?? null;
      this.usuarioEditPermisosAllow = usuario.permisos_allow ?? [];
      this.usuarioEditPermisosDeny = usuario.permisos_deny ?? [];
      this.usuarioEditId = usuario.id;
    },
    cambiarClaveUsuario(id) {
      const usuario = this.usuarios.find(r => r.id == id);
      if (!usuario) return;
      this.modalActive = true;
      this.tipoModal = 'C';
      this.usuarioEditId = usuario.id;
      this.usuarioEditUsername = usuario.username;
      this.usuarioEditEmail = usuario.email;
    },
    mostrarConfirmacionBorrar(id) {
      this.confirmacionVisible = true;
      this.usuarioId = id;
      this.mensajeConfirmacion = '¿Confirma que desea eliminar este usuario?';
    },
    confirmacion() {
      this.confirmacionVisible = false;
      this.borrarUsuario(this.usuarioId);
    },
    cancelacion() {
      this.confirmacionVisible = false;
    },
    async abrirAltaUsuario() {
      this.tipoModal = 'A';
      this.modalActive = true; 
    },
    cerrarModal() {
      this.modalActive = false;
    },
    async cambiarBorrados() {
      await this.initializeDataTable();
    },
    async borrarUsuario(usuarioId) {
      try {
        const resp = await this.$store.dispatch("auth/borraUsuario",{id: usuarioId});
        if (resp.res=='OK') {
            showSwal.methods.showSwal({
                type: "success",
                message: resp.mensaje,
                width: 600,
            });
            this.fetchAndSetUsuarios();
            this.$emit('cerrar-modal');
        }
        else {
            showSwal.methods.showSwal({
                type: "error",
                message: resp.mensaje,
                width: 500
            });               
        }
      } 
      catch (error) {
        showSwal.methods.showSwal({
            type: "error",
            message: "Se ha producido un error",
            width: 500,
        });
      }
    },
    async impersonalizarUsuario(id) {
      const usuario = this.usuarios.find(r => r.id == id);
      if (!usuario || !usuario.rol_id || usuario.rol_id === 1) return;
      const payload = { rol_id: usuario.rol_id, user_id: usuario.id };
      if (usuario.tipster_id) payload.tipster_id = usuario.tipster_id;
      const resp = await this.$store.dispatch("auth/setRolTemporal", payload);
      if (resp?.res === 'OK') {
        showSwal.methods.showSwal({
          type: "success",
          message: `Ahora simulas el rol de "${usuario.username}"`,
          width: 450,
        });
      }
    },
    irInicio() {
      this.$router.push('/dashboard');
    }
  },

  async mounted() {
    this.$store.commit('setShowFooter', true);
    this.cargarColumnasStorage();
    this.initializeDataTable();
    this.listaTipsters = await this.$store.dispatch("auth/listaTipsters") || [];
    const rolesResp = await this.$store.dispatch("auth/listaRoles");
    if (rolesResp?.res === 'OK' && Array.isArray(rolesResp.roles)) {
      this.listaRoles = rolesResp.roles;
    }
  },

};
</script>

<style scoped>
/* ficha-buscador necesita position:relative para que el panel se posicione bien */
.ficha-buscador { position: relative; }

.descarga.triple { grid-template-columns: repeat(3, 1fr); }
.descarga p.activo i { color: var(--q-gold, #ffd700); }

.selector-columnas-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 1rem;
  z-index: 999;
  background: var(--q-card, #1a1f2b);
  border: 1px solid var(--q-border, rgba(255,255,255,.1));
  border-radius: 12px;
  padding: 0;
  min-width: 260px;
  box-shadow: 0 12px 40px rgba(0,0,0,.4);
  overflow: hidden;
}
.selector-columnas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 1rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: var(--q-muted, #888);
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.08));
  background: var(--q-hover, rgba(255,255,255,.04));
}
.selector-reset {
  font-size: 0.72rem;
  color: var(--q-gold, #ffd700);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  opacity: .75;
  transition: opacity .15s;
}
.selector-reset:hover { opacity: 1; }
.selector-columnas-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  padding: 0.5rem;
}
.selector-col-item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background .12s;
  user-select: none;
}
.selector-col-item:hover { background: var(--q-hover, rgba(255,255,255,.06)); }
.selector-col-item input[type="checkbox"] { margin: 0; cursor: pointer; accent-color: var(--q-gold, #ffd700); }
.selector-col-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.borrados {
  display: flex;
  align-items: center;
  gap: 8px;
}
.borrados-label {
  font-size: 0.78rem;
  color: var(--q-muted);
  white-space: nowrap;
}
.filtros-btn-wrap {
  display: flex;
  align-items: center;
  padding: 0 8px;
}
.btn-filtros {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1.5px solid var(--q-border);
  border-radius: 8px;
  background: var(--q-card);
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--q-muted);
  cursor: pointer;
  transition: all 0.2s;
}
.btn-filtros:hover { border-color: var(--q-gold); color: var(--q-gold); }
.btn-filtros.activo {
  border-color: var(--q-gold);
  background: var(--q-hover);
  color: var(--q-gold);
}
.filtro-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: var(--q-gold);
  color: var(--q-gold-on);
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 700;
}
.filtros-panel {
  border: 1px solid var(--q-border);
  border-radius: 10px;
}
.filtros-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px 16px;
  margin-bottom: 16px;
}
.filtro-grupo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.filtro-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--q-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.filtro-input {
  padding: 7px 10px;
  border: 1.5px solid var(--q-border);
  border-radius: 7px;
  font-size: 0.85rem;
  color: var(--q-text);
  background: var(--q-card);
  outline: none;
  transition: border-color 0.2s;
  width: 100%;
}
.filtro-input:focus { border-color: var(--q-gold); }
.filtros-acciones {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding-top: 8px;
  border-top: 1px solid var(--q-border);
}
.btn-f-aplicar {
  padding: 7px 20px;
  background: var(--q-gold);
  color: var(--q-gold-on);
  border: none;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}
.btn-f-aplicar:hover { background: var(--q-gold-hover); }
.btn-f-limpiar {
  padding: 7px 20px;
  background: var(--q-hover);
  color: var(--q-muted);
  border: 1.5px solid var(--q-border);
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
}
.btn-f-limpiar:hover { background: var(--q-border); }
</style>



